var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53033 6.46967C1.23744 6.17678 0.762563 6.17678 0.46967 6.46967C0.176777 6.76256 0.176777 7.23744 0.46967 7.53033L1.53033 6.46967ZM5.46967 12.5303C5.76256 12.8232 6.23744 12.8232 6.53033 12.5303C6.82322 12.2374 6.82322 11.7626 6.53033 11.4697L5.46967 12.5303ZM0.46967 7.53033L5.46967 12.5303L6.53033 11.4697L1.53033 6.46967L0.46967 7.53033Z",
    fill: "#65D83C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5244 1.53015C17.8172 1.23718 17.8171 0.762306 17.5241 0.469494C17.2312 0.176681 16.7563 0.176812 16.4635 0.469786L17.5244 1.53015ZM5.4695 11.4698C5.17669 11.7628 5.17682 12.2377 5.46979 12.5305C5.76276 12.8233 6.23764 12.8232 6.53045 12.5302L5.4695 11.4698ZM16.4635 0.469786L5.4695 11.4698L6.53045 12.5302L17.5244 1.53015L16.4635 0.469786Z",
    fill: "#65D83C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.ef0dca53ab7b2d6744c8ed3ad42fcb6f.svg";
export { ForwardRef as ReactComponent };